import { FC } from 'react';

import {
  BlueRectangle,
  BlueRectangleTypography,
  IconWrapper,
  WhyChooseUsFactsDescription,
  WhyChooseUsFactsTitle,
  WhyChooseUsFactsWrapper,
  WhyChooseUsFactWrapper,
  WhyChooseUsTitle,
  WhyChooseUsWrapper,
} from './WhyChooseUs.styles';

import { IWhyChooseUsData } from 'types/applications';
import { ButtonsWrapper } from '../Hero/Hero.styles';
import { Button } from 'components/Buttons';
import { BOOK_A_DEMO_LINK } from 'constants/common';
import { ButtonWrapper } from 'modules/CustomerCase/Hero/Hero.styles';
import Box from '@mui/material/Box/Box';

const WhyChooseUs: FC<IWhyChooseUsData> = ({ blueBoxTitle, items, title }) => {
  return (
    <WhyChooseUsWrapper>
      <WhyChooseUsTitle>{title}</WhyChooseUsTitle>

      <WhyChooseUsFactsWrapper>
        {items.map((fact, idx) => (
          <WhyChooseUsFactWrapper key={idx}>
            <IconWrapper>
              <img src={fact.imageSrc} alt={fact.title} />
            </IconWrapper>

            <WhyChooseUsFactsTitle>{fact.title}</WhyChooseUsFactsTitle>

            <WhyChooseUsFactsDescription>{fact.description}</WhyChooseUsFactsDescription>
          </WhyChooseUsFactWrapper>
        ))}
      </WhyChooseUsFactsWrapper>

      <BlueRectangle>
        <BlueRectangleTypography>
          {blueBoxTitle}
          <Box marginTop="36px">
            <ButtonsWrapper>
              <ButtonWrapper>
                <a
                  href={BOOK_A_DEMO_LINK}
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: 'none' }}
                >
                  <Button btnType="tertiary" width={240} height={56}>
                    Book a Demo
                  </Button>
                </a>
              </ButtonWrapper>
            </ButtonsWrapper>
          </Box>
        </BlueRectangleTypography>
      </BlueRectangle>
    </WhyChooseUsWrapper>
  );
};

export default WhyChooseUs;
